module.exports = __webpack_public_path__ + "img/hernyo80.6cf0ea55.jpg";